import { hotComments } from "@/mocks/homeData";

export default function HotComments() {
  return (
    <section id="comments" className="w-full border-b border-background-200/70 bg-background-100">
      <div className="mx-auto w-full px-4 py-12 md:px-6 md:py-16">
        <div className="mb-8 md:mb-10">
          <p className="mb-2 flex items-center gap-2 text-xs font-medium uppercase tracking-[0.25em] text-secondary-700">
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-chat-smile-3-line text-sm" />
            </span>
            Comments
          </p>
          <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            围观热评
          </h2>
          <p className="mt-2 max-w-2xl text-sm text-foreground-500 md:text-base">
            评论区才是主战场，这几条被顶得最高。
          </p>
        </div>

        <div className="grid grid-cols-1 gap-5 md:grid-cols-3">
          {hotComments.map((c) => (
            <article
              key={c.id}
              className="flex flex-col rounded-lg border border-background-200 bg-background-50 p-6"
            >
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-accent-100 text-accent-700">
                <i className="ri-double-quotes-l text-lg" />
              </span>
              <p className="mt-4 flex-1 text-[15px] leading-relaxed text-foreground-800">
                {c.content}
              </p>
              <div className="mt-5 flex items-center justify-between border-t border-background-200/80 pt-4">
                <span className="flex items-center gap-2 text-xs text-foreground-500">
                  <span className="flex h-7 w-7 items-center justify-center rounded-full bg-primary-100 text-primary-700">
                    <i className="ri-user-smile-line text-sm" />
                  </span>
                  {c.author}
                </span>
                <span className="flex items-center gap-1.5 text-xs font-medium text-primary-600">
                  <span className="flex h-4 w-4 items-center justify-center">
                    <i className="ri-thumb-up-line text-sm" />
                  </span>
                  {c.likes}
                </span>
              </div>
              <p className="mt-3 flex items-center gap-1.5 text-xs text-foreground-400">
                <span className="flex h-4 w-4 items-center justify-center">
                  <i className="ri-reply-line text-sm" />
                </span>
                {c.reply}
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}